const imageCompare = document.querySelectorAll('.image-compare__inner');

imageCompare.forEach((element) => {
  const comparisonSliderOption = {
    smoothing: false,
    startingPoint: 45,
    fluidMode: true,
  };

  new ImageCompare(element, comparisonSliderOption).mount();
});
